import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectAddOns, selectCurrentShopAddon, setShowLastStepError, setVoiceFormValues } from '@app/redux/addOns';
import { selectConfig } from '@app/redux/config';

import AddonCart from '../../components/AddonCart';
import ConfigureVoiceCard from '../../components/ConfigureVoiceCard';
import { SingleFlowProps } from '../../components/SingleAddonContent';
import { useShopRedirectIfNoSelection } from '../../hooks/use-redirect-to-shop';
import { getTermsAndConditions } from '../../utils';

import styles from '../../styles/configure-voice.module.scss';

const ConfigureVoice = ({ isDesktop, handleContinue, handleBack, continueButtonLabel }: SingleFlowProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ShopAddons');
  const { isPWA } = useSelector(selectConfig);
  const currentShopAddon = useSelector(selectCurrentShopAddon);
  const { availableNumbersLoading } = useSelector(selectAddOns);

  useEffect(() => {
    dispatch(setShowLastStepError(false));
    return () => {
      dispatch(setVoiceFormValues({ directoryListingType: null }));
    };
  }, []);

  useEffect(() => {
    if (!isPWA) {
      return;
    }
    window.scrollTo(0, 0);
  }, []);

  useShopRedirectIfNoSelection();

  if (!currentShopAddon) {
    return null;
  }

  const termsAndConditionsContent = t(`termsAndConditions.${getTermsAndConditions(currentShopAddon.kind)}`);
  const isSubmitDisabled = availableNumbersLoading;

  return (
    <div className={styles['container']}>
      <div className={styles.leftColumn}>
        <ConfigureVoiceCard
          content={termsAndConditionsContent}
          handleBack={handleBack}
          handleSubmit={handleContinue}
          isSubmitDisabled={isSubmitDisabled}
          continueButtonLabel={continueButtonLabel}
        />
      </div>
      {isDesktop && (
        <AddonCart
          handleClick={handleContinue}
          addon={currentShopAddon}
          submitButtonLabel={continueButtonLabel}
          isSubmitDisabled={isSubmitDisabled}
        />
      )}
    </div>
  );
};

export default ConfigureVoice;
